import { Record } from "./fable_modules/fable-library.3.7.1/Types.js";
import { class_type, record_type, array_type, int32_type, string_type } from "./fable_modules/fable-library.3.7.1/Reflection.js";
import { singleton, collect, delay, toArray } from "./fable_modules/fable-library.3.7.1/Seq.js";
import { DataType_DateTime_7F9DDECF, Helpers_Shuffle_404FCA0C, DataType_Number_Z524259A4, Name_LastName, Name_FirstName } from "./Faker.fs.js";
import { rangeDouble } from "./fable_modules/fable-library.3.7.1/Range.js";
import { now } from "./fable_modules/fable-library.3.7.1/Date.js";
import { tail as tail_1, head as head_1, isEmpty } from "./fable_modules/fable-library.3.7.1/List.js";

export class Types_PersonSub extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress, SubRows) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
        this.SubRows = SubRows;
    }
}

export function Types_PersonSub$reflection() {
    return record_type("MakeData.Types.PersonSub", [], Types_PersonSub, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type], ["SubRows", array_type(Types_PersonSub$reflection())]]);
}

export class Types_PersonCreatedAt extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress, CreatedAt) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
        this.CreatedAt = CreatedAt;
    }
}

export function Types_PersonCreatedAt$reflection() {
    return record_type("MakeData.Types.PersonCreatedAt", [], Types_PersonCreatedAt, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type], ["CreatedAt", class_type("System.DateTime")]]);
}

export class Types_Person extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
    }
}

export function Types_Person$reflection() {
    return record_type("MakeData.Types.Person", [], Types_Person, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type]]);
}

const MakeData_statuses = ["relationship", "complicated", "single"];

export function MakeData_make(count) {
    return toArray(delay(() => collect((matchValue) => {
        let Firstname, Lastname, Age, Visits, Progress;
        return singleton((Firstname = Name_FirstName(), (Lastname = Name_LastName(), (Age = (DataType_Number_Z524259A4(40) | 0), (Visits = (DataType_Number_Z524259A4(1000) | 0), (Progress = (DataType_Number_Z524259A4(100) | 0), new Types_Person(Firstname, Lastname, Age, Visits, Helpers_Shuffle_404FCA0C(MakeData_statuses)[0], Progress)))))));
    }, rangeDouble(1, 1, count))));
}

export function MakeData_makeCreatedAt(count) {
    return toArray(delay(() => collect((matchValue) => {
        let Firstname, Lastname, Age, Visits, Progress;
        return singleton((Firstname = Name_FirstName(), (Lastname = Name_LastName(), (Age = (DataType_Number_Z524259A4(40) | 0), (Visits = (DataType_Number_Z524259A4(1000) | 0), (Progress = (DataType_Number_Z524259A4(100) | 0), new Types_PersonCreatedAt(Firstname, Lastname, Age, Visits, Helpers_Shuffle_404FCA0C(MakeData_statuses)[0], Progress, DataType_DateTime_7F9DDECF(now()))))))));
    }, rangeDouble(1, 1, count))));
}

export function MakeData_subMake(count, subCounts) {
    if (isEmpty(subCounts)) {
        return toArray(delay(() => collect((matchValue_1) => {
            let Firstname_1, Lastname_1, Age_1, Visits_1, Progress_1;
            return singleton((Firstname_1 = Name_FirstName(), (Lastname_1 = Name_LastName(), (Age_1 = (DataType_Number_Z524259A4(40) | 0), (Visits_1 = (DataType_Number_Z524259A4(1000) | 0), (Progress_1 = (DataType_Number_Z524259A4(100) | 0), new Types_PersonSub(Firstname_1, Lastname_1, Age_1, Visits_1, Helpers_Shuffle_404FCA0C(MakeData_statuses)[0], Progress_1, [])))))));
        }, rangeDouble(1, 1, count))));
    }
    else {
        return toArray(delay(() => collect((matchValue) => {
            let Firstname, Lastname, Age, Visits, Progress;
            return singleton((Firstname = Name_FirstName(), (Lastname = Name_LastName(), (Age = (DataType_Number_Z524259A4(40) | 0), (Visits = (DataType_Number_Z524259A4(1000) | 0), (Progress = (DataType_Number_Z524259A4(100) | 0), new Types_PersonSub(Firstname, Lastname, Age, Visits, Helpers_Shuffle_404FCA0C(MakeData_statuses)[0], Progress, MakeData_subMake(head_1(subCounts), tail_1(subCounts)))))))));
        }, rangeDouble(1, 1, count))));
    }
}

//# sourceMappingURL=MakeData.fs.js.map
